import { Button, Popconfirm } from "antd";
import moment from "moment";
import { DeleteOutlined, InboxOutlined } from "@ant-design/icons";
import { MyNotif } from "../../components/NotifIcons/NotifIcons";
import { useMutation } from "react-query";
import {
  deleteOneProduct,
  restoreProduct,
} from "../../actions/my-orders/services";

export default function TableRowCancelledDemcoProduct({
  product,
  refetch,
}: any) {
  const { mutateAsync: deleteProduct, isLoading: deleteLoading } = useMutation(
    deleteOneProduct,
    {
      onSuccess: () => {
        MyNotif("Order deleted successfully.", "success");
        refetch();
      },
    }
  );
  const { mutateAsync: restoreOpt, isLoading: restoreLoading } = useMutation(
    restoreProduct,
    {
      onSuccess: () => {
        MyNotif("Order restored successfully.", "success");
        refetch();
      },
    }
  );

  return (
    <tr key={product.id}>
      <td scope="row">
        <span className="myorder_order_name">{product.name}</span>
      </td>
      <td scope="row">
        <span>{product.order_ref}</span>
      </td>
      <td scope="row">
        <span>{moment(product?.canceld_at).format("DD/MM/YYYY")}</span>
      </td>
      <td>
        <div>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to delete this order ?"}
            onConfirm={() =>
              deleteProduct({
                order_id: product.order_id,
                product_id: product.id,
              })
            }
            okText="Yes"
            cancelText="No"
          >
            <Button
              type="ghost"
              size={"middle"}
              className="mr-2"
              style={{ borderRadius: "4px" }}
              icon={<DeleteOutlined style={{ color: "#00468c" }} />}
              loading={deleteLoading}
            >
              Delete
            </Button>
          </Popconfirm>
          <Popconfirm
            placement="top"
            title={"Are you sure you want to restore this order ?"}
            onConfirm={() =>
              restoreOpt({
                order_id: product.status.order_id,
                product_id: product.id,
              })
            }
            okText="Yes"
            cancelText="No"
          >
            <Button
              size={"middle"}
              style={{ borderRadius: "4px" }}
              icon={
                <InboxOutlined
                  style={{ color: "#00468c", verticalAlign: "1px" }}
                />
              }
              loading={restoreLoading}
            >
              Restore
            </Button>
          </Popconfirm>
        </div>
      </td>
    </tr>
  );
}
